export interface AgentTool {
  id: string;
  name: string;
  description: string;
}

export const AVAILABLE_TOOLS: AgentTool[] = [
  {
    id: "output_social_posts",
    name: "Social Posts",
    description: "Generate social media posts for all platforms",
  },
  {
    id: "output_blog",
    name: "Blog",
    description: "Write and publish a blog post",
  },
  {
    id: "generate_image",
    name: "Generate Image",
    description: "Generate AI images",
  },
];
